import { axios } from '@/utils/request'

/**
 * 商品列表
 * @param parameter
 * @returns {*}
 */
export function getGoodsList (parameter) {
  return axios({
    url: '/goods/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 编辑商品
 * @param parameter
 * @returns {*}
 */
export function editGoods (parameter) {
  return axios({
    url: '/goods/edit/' + parameter.id,
    method: 'post',
    data: parameter
  })
}

/**
 * 新增商品
 * @param parameter
 * @returns {*}
 */
export function addGoods (parameter) {
  return axios({
    url: '/goods/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除商品
 * @param parameter
 * @returns {*}
 */
export function deleteGoods (parameter) {
  return axios({
    url: '/goods/delete',
    method: 'post',
    data: parameter
  })
}
